var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"centered":"","title":"提示","visible":_vm.visible},on:{"cancel":_vm.cancel}},[_vm._t("context"),_c('template',{slot:"footer"},[_c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.cancel}},[_vm._v("确定")])],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }